import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { fetchSuppliers, selectAllSuppliers } from '../../../slices/suppliers/suppliersSlice';
import { selectAllCompanies } from '../../../slices/companies/companiesSlice';

export const useSupplierProfiles = () => {
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectAllCompanies)[0];
  const suppliers = useAppSelector(selectAllSuppliers);
  const suppliersCount = useAppSelector((state) => state.suppliers.suppliersCount);
  const suppliersLoading = useAppSelector((state) => state.suppliers.status);
  const [cardView, setCardView] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchString, setSearchString] = useState('');
  const [searchStringInputValue, setSearchStringInputValue] = useState('');
  const [searchCleared, setSearchCleared] = useState(false);

  const searchParams: {
    company_id: number;
    sort?: string;
    order?: string;
    name?: string;
    page?: number;
  } = useMemo(
    () => ({
      company_id: company?.id,
      name: searchString,
      sort: 'name',
      order: 'ASC',
    }),
    [company?.id, searchString]
  );

  const getNextPage = () => {
    dispatch(
      fetchSuppliers({
        ...searchParams,
        page: currentPage + 1,
      })
    );
    setCurrentPage(currentPage + 1);
  };

  const getRequestedPage = (page: number) => {
    dispatch(
      fetchSuppliers({
        ...searchParams,
        page,
      })
    );
    setCurrentPage(page);
  };

  const getPrevPage = () => {
    dispatch(
      fetchSuppliers({
        ...searchParams,
        page: currentPage - 1,
      })
    );
    setCurrentPage(currentPage - 1);
  };

  const setSearchStringValue = useCallback(() => {
    if (suppliersLoading !== 'loading') {
      setSearchString(searchStringInputValue);
    }
  }, [suppliersLoading, setSearchString, searchStringInputValue]);

  const resetSearchFilter = useCallback(() => {
    setSearchString('');
    setSearchStringInputValue('');
    setSearchCleared(true);
    delete searchParams.name;
    //dispatch(fetchSuppliers({ ...searchParams, page: currentPage }));
  }, [searchParams, setSearchCleared, setSearchString]);

  const fetchSuppliersArray = useCallback(() => {
    dispatch(fetchSuppliers({ ...searchParams, page: currentPage }));
  }, [currentPage, dispatch, searchParams]);

  useEffect(() => {
    setSearchStringValue();
  }, [setSearchStringValue]);

  useEffect(() => {
    fetchSuppliersArray();
  }, [fetchSuppliersArray]);

  /*useEffect(() => {
    return () => {
      resetSearchFilter();
    };
  }, [resetSearchFilter]);*/

  return {
    cardView,
    setCardView,
    suppliers,
    suppliersLoading,
    getNextPage,
    getPrevPage,
    getRequestedPage,
    currentPage,
    setCurrentPage,
    suppliersCount,
    searchString,
    setSearchString,
    resetSearchFilter,
    searchCleared,
    setSearchCleared,
    searchStringInputValue,
    setSearchStringInputValue,
  };
};
